import React from 'react';
import styled from 'styled-components';
const SVG = styled.svg `
  &:hover {
    path {
      fill: ${({ theme }) => theme.primaryRed};
    }
  }

  &:focus,
  &:active {
    circle:first-of-type {
      fill-opacity: 1;
    }

    path {
      fill: ${({ theme }) => theme.primaryBlack};
    }
  }
`;
export const PlayIcon = ({ size }) => {
    const validatedSize = size ? size : 50;
    return (React.createElement(SVG, { viewBox: "0 0 50 50", fill: "none", xmlns: "http://www.w3.org/2000/svg", height: validatedSize, width: validatedSize },
        React.createElement("circle", { cx: "25", cy: "25", r: "25", fill: "#1B1B1B", fillOpacity: "0.5" }),
        React.createElement("circle", { cx: "25", cy: "25", r: "21", fill: "white" }),
        React.createElement("path", { d: "M22 17L31 25L22 33V17Z", fill: "#1B1B1B" })));
};
